var React = require('react');

function MenuCloseInline (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_577_12546","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"40","height":"41","key":0},React.createElement("rect",{"y":"0.686523","width":"40","height":"40","fill":"currentColor"})),React.createElement("g",{"mask":"url(#mask0_577_12546)","key":1},React.createElement("path",{"d":"M10.6665 31.7761L8.91016 30.0197L18.2435 20.6864L8.91016 11.3531L10.6665 9.59668L19.9999 18.93L29.3332 9.59668L31.0896 11.3531L21.7562 20.6864L31.0896 30.0197L29.3332 31.7761L19.9999 22.4428L10.6665 31.7761Z","fill":"currentColor"}))]);
}

MenuCloseInline.defaultProps = {"width":"40","height":"41","viewBox":"0 0 40 41","fill":"none"};

module.exports = MenuCloseInline;

MenuCloseInline.default = MenuCloseInline;
